import React from "react";
import { Link } from "react-router-dom";
import styles from "./style.module.css";
import BlitzLogo from "../../../assets/images/blitz_logo.svg";
import { track } from "../../../analytics";

// Site footer from the Claude Design file "Track Parcel.dc.html".
// Used on every page (the homepage renders it inside its own full-height layout).

const LINKS = [
  { name: "About Us", to: "/aboutus", cta: "footer_about" },
  { name: "Terms of Service", to: "/terms-of-service", cta: "footer_terms" },
  { name: "Privacy Policy", to: "/privacy-policy", cta: "footer_privacy" },
];
const cta = (name) => () => track("tp_cta_click", { cta: name, placement: "footer" });

const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.inner}>
      <div className={styles.grid}>
        <div className={styles.brand}>
          <Link to="/" aria-label="Blitz home" className={styles.logoLink}>
            <img src={BlitzLogo} alt="blitz" className={styles.logo} />
          </Link>
          <p className={styles.about}>
            Blitz is a network of technologically integrated fulfillment centers &amp; shipping partners to achieve Same Day Delivery in India for eCommerce sellers.
          </p>
        </div>

        <nav className={styles.col} aria-label="Important links">
          <span className={styles.heading}>Important Links</span>
          <div className={styles.links}>
            {LINKS.map((l) => (
              <Link key={l.to} to={l.to} className={styles.link} onClick={cta(l.cta)}>
                {l.name}
              </Link>
            ))}
          </div>
        </nav>

        <div className={styles.col}>
          <span className={styles.heading}>Contact Us</span>
          <div className={styles.contacts}>
            <a href="mailto:buyer-support@blitznow.in" className={`${styles.link} ${styles.contact}`} onClick={cta("footer_email")}>
              <span className={styles.tile}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <rect x="3" y="5" width="18" height="14" rx="3" />
                  <path d="M4 7l8 6 8-6" />
                </svg>
              </span>
              buyer-support@blitznow.in
            </a>
            <a href="tel:+918035316943" className={`${styles.link} ${styles.contact} ${styles.tel}`} onClick={cta("footer_call")}>
              <span className={styles.tile}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M5 4h4l2 5-2.5 1.5a11 11 0 005 5L15 13l5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z" />
                </svg>
              </span>
              +91 8035316943
            </a>
          </div>
        </div>
      </div>

      <div className={styles.bottom}>
        <span>© {new Date().getFullYear()} Blitz. All rights reserved.</span>
        <span className={styles.tagline}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="#7130F0" aria-hidden="true">
            <path d="M13 2L4 14h7l-1 8 9-12h-7z" />
          </svg>
          Same Day Delivery across India
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
